import React, { Component } from "react";
import { Button, Container } from "semantic-ui-react";
import DropzoneCommon from "./DropzoneCommon";

class UploadImageForm extends Component {
  render() {
    const {
      backgroundImage,
      id: i,
      handleDrop,
      handleDelete,
      videoFile,
      accept
    } = this.props;
    return (
      <Container text>
        <DropzoneCommon
          onDrop={files => handleDrop(i, files[0])}
          accept={accept}
          acceptClassName="green"
          activeClassName="secondary"
          rejectClassName="red"
          className="ui dropzone"
          img={backgroundImage}
          video={videoFile}
          dropzoneMinHeight="5rem"
          dropzoneMaxWidth="50%"
        />

        {backgroundImage && <div>
          <Button
            color="red"
            icon="trash"
            content="Delete Image"
            onClick={e => {
              handleDelete(i);
            }}
          />
        </div>
        }
        {videoFile && <div>
          <Button
            color="red"
            icon="trash"
            content="Delete Video"
            onClick={e => {
              handleDelete(i);
            }}
          />
        </div>
        }
      </Container>
    );
  }
}

export default UploadImageForm;
